// extracted by mini-css-extract-plugin
module.exports = {"container":"KeywordSearchGroupForCompanies_container__3WmlE","sending":"KeywordSearchGroupForCompanies_sending__2WQ8Y"};